import { Lemonade, setConfig, useLemonadeQuestion } from '@oneclick/react-lemonade-editor';
import PropTypes from 'prop-types';
import React, { forwardRef, useImperativeHandle } from 'react';

// Configure Lemonade once per module
setConfig({
  mathRenderEngine: 'mathjax',
  chartsEnable: true,
});

// eslint-disable-next-line react/prop-types -- los propTypes van sobre el componente final (al pie)
function LemonadeActivityInner({ exercise, onInteraction }, ref) {
  const {
    exercise: { Question, Feedback, questionApi: store },
  } = useLemonadeQuestion({
    data: exercise,
  });

  useImperativeHandle(
    ref,
    function () {
      return {
        checkAnswers: function () {
          return store.checkAnswers();
        },
        getResponse: function () {
          return store.getResponse();
        },
        getUserResponse: function () {
          return store.getUserResponse();
        },
        showSolutions: function () {
          return store.showSolutions();
        },
        reset: function () {
          return store.reset();
        },
        setResponse: function (value) {
          return store.setResponse(value);
        },
      };
    },
    [store]
  );

  return (
    <Lemonade>
      <Question
        changed={function () {
          if (onInteraction) onInteraction(true);
        }}
      />
      <Feedback />
    </Lemonade>
  );
}

const LemonadeActivity = React.memo(forwardRef(LemonadeActivityInner), function propsAreEqual(prevProps, nextProps) {
  const prevId = prevProps.exercise?.id || prevProps.exercise?.data?.id;
  const nextId = nextProps.exercise?.id || nextProps.exercise?.data?.id;
  return prevId === nextId;
});

// Sobre el componente final y no sobre la función de forwardRef: React avisa al importar el módulo si
// la función interna lleva propTypes, y memo/forwardRef validan los del tipo exterior.
LemonadeActivity.propTypes = {
  exercise: PropTypes.object.isRequired,
  onInteraction: PropTypes.func,
};

export default LemonadeActivity;
